var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatisticsSold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E6F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9335 19.613H15.2602C14.1668 19.613 13.2802 18.693 13.2802 17.5597C13.2802 17.2863 13.5068 17.0597 13.7802 17.0597C14.0535 17.0597 14.2802 17.2863 14.2802 17.5597C14.2802 18.1397 14.7202 18.613 15.2602 18.613H16.9335C17.3668 18.613 17.7268 18.2263 17.7268 17.7597C17.7268 17.1797 17.5202 17.0663 17.1802 16.9463L14.4935 15.9997C13.9735 15.8197 13.2735 15.433 13.2735 14.2397C13.2735 13.213 14.0802 12.3863 15.0668 12.3863H16.7402C17.8335 12.3863 18.7202 13.3063 18.7202 14.4397C18.7202 14.713 18.4935 14.9397 18.2202 14.9397C17.9468 14.9397 17.7202 14.713 17.7202 14.4397C17.7202 13.8597 17.2802 13.3863 16.7402 13.3863H15.0668C14.6335 13.3863 14.2735 13.773 14.2735 14.2397C14.2735 14.8197 14.4802 14.933 14.8202 15.053L17.5068 15.9997C18.0268 16.1797 18.7268 16.5663 18.7268 17.7597C18.7202 18.7797 17.9202 19.613 16.9335 19.613Z",
    fill: "#26B5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 20.4997C15.7268 20.4997 15.5002 20.273 15.5002 19.9997V11.9997C15.5002 11.7263 15.7268 11.4997 16.0002 11.4997C16.2735 11.4997 16.5002 11.7263 16.5002 11.9997V19.9997C16.5002 20.273 16.2735 20.4997 16.0002 20.4997Z",
    fill: "#26B5ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 23.1663H14.0002C10.3802 23.1663 8.8335 21.6197 8.8335 17.9997V13.9997C8.8335 10.3797 10.3802 8.83301 14.0002 8.83301H18.0002C21.6202 8.83301 23.1668 10.3797 23.1668 13.9997V17.9997C23.1668 21.6197 21.6202 23.1663 18.0002 23.1663ZM14.0002 9.83301C10.9268 9.83301 9.8335 10.9263 9.8335 13.9997V17.9997C9.8335 21.073 10.9268 22.1663 14.0002 22.1663H18.0002C21.0735 22.1663 22.1668 21.073 22.1668 17.9997V13.9997C22.1668 10.9263 21.0735 9.83301 18.0002 9.83301H14.0002Z",
    fill: "#26B5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsSold);
export default __webpack_public_path__ + "static/media/statistics-sold.5c75d030a368066b342cde50b42ce7ff.svg";
export { ForwardRef as ReactComponent };